import React from "react";
import classNames from "classnames";
import { IconProps } from "../type";

export function ProfileColorIcon({ className, style, ...props }: IconProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className={classNames(["h-full w-full", className])}
      style={style}
      viewBox='0 0 90 90'
      fill='none'
      {...props}
    >
      <rect
        x='1'
        y='1'
        width='88'
        height='88'
        rx='44'
        stroke='url(#paint0_linear_1439_28783)'
        strokeWidth='2'
      />
      <g clipPath='url(#clip0_1439_28783)'>
        <path
          d='M58.6013 62H31.3748C30.8674 61.7576 30.6735 61.3585 30.6782 60.7954C30.6954 58.5821 30.6895 56.3687 30.6842 54.1548C30.6647 52.1081 31.1758 50.0914 32.1677 48.3011C33.7402 45.4582 36.0644 43.5596 39.2605 42.7966C39.3654 42.7721 39.5195 42.802 39.5527 42.6864C39.5859 42.5709 39.4345 42.5171 39.3568 42.4467C35.1101 38.5885 36.0139 31.5833 41.0993 28.9244C42.0124 28.4476 42.9819 28.1654 43.992 28H45.9842C46.0506 28.0146 46.1123 28.0345 46.1767 28.0438C49.9911 28.6016 52.9728 31.7095 53.2908 35.5477C53.5166 38.2704 52.5922 40.5886 50.5967 42.4693C50.5303 42.5357 50.3902 42.5768 50.4261 42.6871C50.4579 42.784 50.5928 42.7727 50.6917 42.794C51.4613 42.9646 52.2137 43.1957 52.911 43.563C57.0388 45.7305 59.0662 49.25 59.2714 53.8261C59.3763 56.145 59.2807 58.4745 59.2979 60.7987C59.3019 61.3578 59.1087 61.7576 58.6013 62ZM44.9675 59.9819H56.8177C57.2387 59.9819 57.2467 59.9733 57.2473 59.5509C57.2473 57.8802 57.2526 56.2094 57.2473 54.5386C57.2552 53.7861 57.1903 53.0347 57.0534 52.2947C56.473 49.4001 55.0048 47.115 52.411 45.6269C51.1492 44.9044 49.7726 44.6308 48.3323 44.6275C48.1649 44.6275 48.0003 44.6427 48.0089 44.8605C48.0301 45.8102 47.8967 46.7697 48.072 47.708C48.4545 49.762 48.8781 51.808 49.2932 53.8553C49.3981 54.3713 49.2746 54.785 48.8615 55.1256C47.8389 55.9716 46.8282 56.8336 45.8069 57.6823C45.2092 58.1816 44.7729 58.1816 44.1786 57.6869C43.1499 56.8296 42.1299 55.9604 41.0993 55.1077C40.7075 54.783 40.58 54.3839 40.6783 53.8958C40.9034 52.7795 41.1113 51.6599 41.3523 50.5476C41.7508 48.7188 42.118 46.8906 41.9819 45.0007C41.9633 44.7417 41.9068 44.6221 41.6219 44.6228C39.5374 44.6295 37.6787 45.2643 36.1102 46.6442C33.7953 48.6769 32.7799 51.2993 32.7374 54.3307C32.7129 56.0573 32.7321 57.7839 32.7328 59.5104C32.7328 59.9826 32.7328 59.9832 33.2202 59.9832L44.9675 59.9819ZM44.9834 42.5835C48.487 42.5171 51.2548 39.817 51.2535 36.2988C51.2535 32.8091 48.5182 30.05 45.0113 30.036C41.527 30.0227 38.7326 32.7547 38.724 36.2895C38.7127 39.7898 41.4685 42.5098 44.9834 42.5815V42.5835ZM45.002 48.6138C44.7586 48.6244 44.5148 48.6226 44.2715 48.6085C43.9561 48.5766 43.818 48.6975 43.7589 49.007C43.4687 50.5257 43.1645 52.0411 42.8558 53.5558C42.8172 53.743 42.8478 53.8719 42.9939 53.9927C43.5893 54.4864 44.1819 54.984 44.7716 55.4855C44.9276 55.6184 45.0538 55.6144 45.2072 55.4855C45.7962 54.9835 46.3899 54.4895 46.9836 53.9907C47.1024 53.8918 47.1649 53.7849 47.131 53.6175C46.8114 52.049 46.4966 50.4792 46.1867 48.908C46.1402 48.6716 46.018 48.6012 45.7962 48.6105C45.5333 48.6205 45.2676 48.6118 45.002 48.6118V48.6138ZM45.0067 44.6295C44.7756 44.6295 44.5418 44.6341 44.3127 44.6295C44.1009 44.6235 44.0139 44.7198 44.0165 44.9283C44.0225 45.3798 44.0205 45.8321 44.0165 46.2836C44.0165 46.4736 44.0936 46.5718 44.2908 46.5705C44.7539 46.567 45.2167 46.567 45.6794 46.5705C45.8753 46.5705 45.9603 46.4809 45.9569 46.2883C45.9529 46.0572 45.9569 45.8234 45.9569 45.5937C45.9583 44.6275 45.9583 44.6275 45.0067 44.6281V44.6295Z'
          fill='url(#paint1_linear_1439_28783)'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_1439_28783'
          x1='0'
          y1='0'
          x2='93.2975'
          y2='3.55902'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FE901F' />
          <stop offset='1' stopColor='#A94AC7' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_1439_28783'
          x1='30.6781'
          y1='28'
          x2='60.3833'
          y2='28.9546'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FE901F' />
          <stop offset='1' stopColor='#A94AC7' />
        </linearGradient>
        <clipPath id='clip0_1439_28783'>
          <rect width='28.6437' height='34' fill='white' transform='translate(30.6782 28)' />
        </clipPath>
      </defs>
    </svg>
  );
}
